interface CachedAudio {
  blob: Blob;
  timestamp: number;
}

interface TTSCacheRequest {
  text: string;
  language: string;
  voice?: string;
}

class TTSCache {
  private cache = new Map<string, CachedAudio>();
  private readonly CACHE_DURATION_MS = 15 * 1000; // 15 seconds

  private generateCacheKey(request: TTSCacheRequest): string {
    const { text, language, voice = 'nova' } = request;
    return `${language}:${voice}:${text}`;
  }

  private isExpired(cachedAudio: CachedAudio): boolean {
    return Date.now() - cachedAudio.timestamp > this.CACHE_DURATION_MS;
  }

  get(request: TTSCacheRequest): Blob | null {
    const key = this.generateCacheKey(request);
    const cachedAudio = this.cache.get(key);

    if (!cachedAudio || this.isExpired(cachedAudio)) {
      if (cachedAudio) {
        this.cache.delete(key);
      }
      return null;
    }

    return cachedAudio.blob;
  }

  set(request: TTSCacheRequest, blob: Blob): void {
    const key = this.generateCacheKey(request);
    this.cache.set(key, {
      blob,
      timestamp: Date.now()
    });
  }
}

// Global singleton instance
export const ttsCache = new TTSCache();
